<!-- @format -->

<sis-expandable
  [title]="'PROFILE.STUDY_PATH.INTERNATIONAL_CONTRACTUAL_DEGREE_INFO' | translate"
  [variant]="'link'"
  data-cy="international-contractual-degree-button"
  [level]="level">
  <ng-template sisExpandableContent>
    <sis-description-list>
      <dl>
        <ng-template #listItem>
          <dt class="sis-label">{{ "PROFILE.STUDY_PATH.INTERNATIONAL_CONTRACTUAL_DEGEE_AGREEMENT" | translate }}</dt>
          <dd>{{ internationalContractualDegreeAgreement.name | localizedString }}</dd>
        </ng-template>
        @if (internationalContractualDegreeAgreement.type === "JOINT") {
          <ng-template #listItem>
            <dt class="sis-label">{{ "PROFILE.STUDY_PATH.INTERNATIONAL_INSTITUTIONS" | translate }}</dt>
            @for (attainableDegree of internationalContractualDegree.attainableDegrees; track attainableDegree) {
              <dd>
                {{ attainableDegree.internationalInstitutionUrn | codeLocalizedName | async }}
              </dd>
            }
          </ng-template>
        }
        @if (internationalContractualDegreeAgreement.type === "DOUBLE") {
          <ng-container>
            @for (attainableDegree of internationalContractualDegree.attainableDegrees; track attainableDegree) {
              <ng-template #listItem>
                <dt class="sis-label">{{ "PROFILE.STUDY_PATH.DEGREE_NAME_AND_INTERNATIONAL_INSTITUTION" | translate }}</dt>
                <dd>{{ attainableDegree.degreeName }}</dd>
                <dd>{{ attainableDegree.internationalInstitutionUrn | codeLocalizedName | async }}</dd>
              </ng-template>
            }
          </ng-container>
        }
      </dl>
    </sis-description-list>
  </ng-template>
</sis-expandable>
